import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdlePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
    if (route.data?.['preload'] === false || connection?.saveData) {
      return of(null);
    }

    const runWhenIdle = (cb: () => void): void => {
      if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(cb, { timeout: 5000 });
      } else {
        setTimeout(cb, 2000);
      }
    };

    runWhenIdle(() => load().subscribe());
    return of(null);
  }
}
